module.exports = __webpack_public_path__ + "static/Bando_IAT-618a6018b2195d0a47e7463a26bf79a7.pdf";